import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ShieldIcon } from '@/components/ui/Icons/Icons';
import { Z_INDEX } from '@/constants/z-index';
import { useOverlayClickHandler } from '@/hooks/useOverlayClickHandler';

import * as S from './Statuses.styles';

export type SuccessTopUpProps = {
  onClose: () => void;
};

export const SuccessTopUp: FC<SuccessTopUpProps> = ({ onClose }) => {
  const { t } = useTranslation();

  const handleOverlayClick = useOverlayClickHandler(onClose);

  return (
    <S.StatusModalOverlay onClick={handleOverlayClick} $zIndex={Z_INDEX.DIALOG}>
      <S.StatusModalCard>
        <S.StatusIconWrapper $isStatus $isTransparent>
          {<ShieldIcon />}
        </S.StatusIconWrapper>
        <S.ContentWrapper>
          <S.StatusModalTitle>
            {t('InsufficientBalanceModal.success_top_up')}
          </S.StatusModalTitle>
        </S.ContentWrapper>
        <S.ConfirmButton variant="primary" size="m" onClick={onClose}>
          {t('Advertise.success_button')}
        </S.ConfirmButton>
      </S.StatusModalCard>
    </S.StatusModalOverlay>
  );
};
